import type { InputHTMLAttributes } from "react";
import { Search } from "lucide-react";
import { MAX_SEARCH_QUERY_LENGTH } from "../lib/search";

type SearchInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "maxLength" | "onChange" | "value"> & {
  value: string;
  onChange: (value: string) => void;
  wrapperClassName?: string;
  iconClassName?: string;
};

export function SearchInput({
  value,
  onChange,
  className = "field pl-9",
  wrapperClassName = "",
  iconClassName = "w-4 h-4 absolute left-3 top-3.5 text-mut",
  ...inputProps
}: SearchInputProps) {
  const limitMessageId = inputProps.id ? `${inputProps.id}-limit` : undefined;
  const describedBy = [inputProps["aria-describedby"], limitMessageId].filter(Boolean).join(" ") || undefined;
  const reachedLimit = value.length >= MAX_SEARCH_QUERY_LENGTH;
  const boundedValue = value.slice(0, MAX_SEARCH_QUERY_LENGTH);

  return (
    <div className={wrapperClassName}>
      <div className="relative">
        <Search className={iconClassName} aria-hidden="true" />
        <input
          {...inputProps}
          className={className}
          value={boundedValue}
          maxLength={MAX_SEARCH_QUERY_LENGTH}
          aria-describedby={describedBy}
          onChange={(event) => onChange(event.target.value.slice(0, MAX_SEARCH_QUERY_LENGTH))}
        />
      </div>
      {reachedLimit && (
        <p id={limitMessageId} role="status" className="mt-1 text-[11px] font-semibold text-brand-red">
          Maximum {MAX_SEARCH_QUERY_LENGTH} characters.
        </p>
      )}
    </div>
  );
}
